module.exports = "/src/views/player/hudevo/ipad/assets/images/maps.png";